import angular from 'angular';
import uiRouter from 'angular-ui-router';
import clientComponent from './client.component';
import clientListComponent from './client-list.component';
import clientDetailComponent from './client-detail.component';
import clientReportComponent from './client-report.component';
import clientService from './client.service';

let clientModule = angular.module('client', [
  uiRouter
])

.service('Client', clientService)

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/client');

  $stateProvider
    .state('client', {
      component: 'client'
    })
    .state('client.list', {
      url: '/client',
      component: 'clientList'
    })
    .state('client.create', {
      url: '/client/new',
      component: 'clientDetail',
      params: {
      	id: ""
      }
    })
    .state('client.edit', {
      url: '/client/:id/edit',
      component: 'clientDetail',
      params: {
        id: ""
      }
    })
    .state('client.report', {
      url: '/client/report',
      component: 'clientReport'
    });
})

.component('client', clientComponent)
.component('clientList', clientListComponent)
.component('clientDetail', clientDetailComponent)
.component('clientReport', clientReportComponent)

.name;

export default clientModule;



// WEBPACK FOOTER //
// ./client/app/components/client/client.js